'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { trackCtaSelection } from '@feat/feat-tracking/cta';
import { useState } from 'react';
import { useExperienceOptions } from '../_hooks/use-app-experience-options';
import { getSelectionFromFilter, initSelectedOptions } from '../_lib/experience-booking-utils';
import { useExperienceFilterContext } from './app-experience-filter-provider';
import { AppVariantSelect } from './app-variant-select';
type AppVariantModalContentProps = {
  onClose: () => void;
};
function AppVariantModalContent(t0) {
  const $ = _c(16);
  const {
    onClose
  } = t0;
  const {
    filter,
    setFilter,
    variants
  } = useExperienceFilterContext();
  const [selectedVariantId, setSelectedVariantId] = useState(filter.selectedVariant ?? undefined);
  const {
    getVariantOptions
  } = useExperienceOptions(variants);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = variantId => {
      setSelectedVariantId(variantId);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleVariantChange = t1;
  let t2;
  if ($[1] !== filter || $[2] !== getVariantOptions || $[3] !== onClose || $[4] !== selectedVariantId || $[5] !== setFilter || $[6] !== variants) {
    t2 = () => {
      if (!selectedVariantId) {
        return;
      }
      const variantHasChanged = selectedVariantId !== filter.selectedVariant;
      const updatedFilter = variantHasChanged ? {
        ...filter,
        selectedVariant: selectedVariantId,
        selectedOptions: initSelectedOptions(getVariantOptions(selectedVariantId) ?? [])
      } : filter;
      if (variantHasChanged) {
        const selection = getSelectionFromFilter(updatedFilter, variants);
        trackCtaSelection("take over - option", {
          selection,
          type: "experience"
        });
        setFilter(updatedFilter);
      }
      onClose();
    };
    $[1] = filter;
    $[2] = getVariantOptions;
    $[3] = onClose;
    $[4] = selectedVariantId;
    $[5] = setFilter;
    $[6] = variants;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleSubmit = t2;
  let t3;
  if ($[8] !== handleSubmit) {
    t3 = () => <Modal.Footer><Modal.Footer.Actions><Modal.Footer.Button onClick={handleSubmit}>Übernehmen</Modal.Footer.Button></Modal.Footer.Actions></Modal.Footer>;
    $[8] = handleSubmit;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== selectedVariantId || $[11] !== variants) {
    t4 = <AppVariantSelect variants={variants} initialSelectedVariant={selectedVariantId} onChange={handleVariantChange} />;
    $[10] = selectedVariantId;
    $[11] = variants;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <Modal.Content renderFooter={t3}>{t4}</Modal.Content>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
type AppVariantModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function AppVariantModal(t0) {
  const $ = _c(6);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = props => <><Modal.Header onClose={onClose}>Option wählen</Modal.Header><AppVariantModalContent {...props} /></>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== onClose || $[4] !== t1) {
    t2 = <Modal isOpen={isOpen} onClose={onClose}>{t1}</Modal>;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}